import { mountApp } from '@moneytome/app-kit';
import { createRouter } from '@tanstack/react-router';

import './env';
import { i18n } from './shared/i18n';
import './styles.css';
import { registerApplyWebAnalyticsSink } from './features/apply/web-analytics-sink';
import { subscribeToRouteChanges } from './shared/lib/web-analytics-router';
import { initWebAnalytics, resolveWebAnalyticsConfig } from './shared/lib/web-analytics';
import { routeTree } from './routeTree.gen';
import { initializePageMetadata } from './shared/lib/page-metadata-router';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

initializePageMetadata(router, i18n);
initWebAnalytics(resolveWebAnalyticsConfig(location.hostname));
registerApplyWebAnalyticsSink();
subscribeToRouteChanges(router);

mountApp(router);
